import React from 'react';
import { IStateDispatchActions } from '../ContestSetup.context';

export type ISearch = (
  searchValue: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
) => void;

export const search: IStateDispatchActions<ISearch> = (_, dispatch) => async searchValue => {
  dispatch({ type: 'setPlayerLookupValue', value: searchValue.target.value });
};
